module.exports = __webpack_public_path__ + "img/qr-android.ac082538.png";